import React from 'react';

const RacingLimitsGame = () => {
  return (
    <div style={{ width: '100%', height: '100vh' }}>
  <iframe src="https://www.crazygames.com/embed/racing-limits"         style={{ width: '100%', height: '100%', border: 'none' }}
frameborder="0" allow="gamepad *;"></iframe>

    </div>
  );
};

export default RacingLimitsGame;
